import PropTypes from "prop-types"
import { useContext, useEffect, useState } from "react"
import { useMutation, useQuery } from "react-query"
import { createClient, listClients } from "~/actions/clients"
import ClientsCardList from "~/components/Clients/ClientsCardList"
import AdminActionBar from "~/components/Common/AdminActionBar"
import AppContext from "~/contexts/App"
import Page from "~/pages/Page"
import Router from "~/router"

import useStyles from "./styles"

const List = ({ routes = [], ...rest }) => {
  const classes = useStyles()
  const { authUser, openDialog, setPageTitle, setPageSubTitle } =
    useContext(AppContext)
  const createClientMutation = useMutation(createClient)
  const { data: clients, refetch: refetchClients } = useQuery(
    "clients",
    () => listClients(),
    { enabled: !!authUser },
  )

  const [searchValue, setSearchValue] = useState("")

  // reference sortType and sortHelper for understanding of this object
  const [sort, setSort] = useState({
    name: "",
    type: "",
    direction: "",
    icon: "",
  })

  // sortation options - name only at this point.
  const filterOptions = [
    { id: 1, name: "name" },
    { id: 2, name: "codes" },
  ]

  //set title and subtitle
  useEffect(() => {
    setPageTitle("Clients")
    setPageSubTitle(clients?.length)
  }, [clients])

  // reusable dialog to create lessons, courses, clients and instructor
  // pass a title, subtitle, type (for example course) a create mutation func and refecth data
  const openCreateDialog = () => {
    let data = {
      title: "New Client",
      subtitle: "Create a new Client",
      type: "client",
      create: createClientMutation,
      listData: clients,
    }
    openDialog("createClientDialog", data)
  }
  return (
    <Page>
      <AdminActionBar
        buttonName="New Client"
        buttonFunc={openCreateDialog}
        sortOptions={filterOptions}
        sortState={sort}
        setSortState={setSort}
        setFilterState={setSearchValue}
        placeholder="Search clients"
      />
      <ClientsCardList
        searchValue={searchValue}
        sort={sort}
        openCreateDialog={openCreateDialog}
      />

      <Router routes={routes} {...rest} />
    </Page>
  )
}

List.propTypes = {
  routes: PropTypes.array,
}

export default List
